import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  schema?: Record<string, any> | Array<Record<string, any>>;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  schema,
  image,
  url,
  type = "website",
}) => {
  const siteTitle = title 
    ? `${title} | Consultoria Global`
    : "Consultoría de Sistemas y Tecnología | Consultoria Global";

  const defaultDescription =
    "Ofrecemos servicios de consultoría tecnológica para optimizar procesos, mejorar la eficiencia y transformar digitalmente su negocio.";

  const metaDescription = description || defaultDescription;

  const resolvedUrl = url || window.location.href;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={resolvedUrl} />
      {image && <meta property="og:image" content={image} />}

      {/* Canonical Link */}
      <link rel="canonical" href={resolvedUrl} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
